import styled from "@emotion/styled";
import React from "react";
import { useTravelTimesEstimator } from "../hooks/useTravelTimesEstimator";
import { Geo } from "../messages";
import { DirectionsBusIcon, DirectionsCarRoundedIcon, DirectionsWalkIcon } from "../utils/icones";
import QueryRenderer from "./QueryRenderer";
import { TextShimmer } from "./Shimmer";

export default function TravelTimeEstimator(props: { source: Geo; destination: Geo }) {
  const travelTimes = useTravelTimesEstimator(props);

  return (
    <TransportationsWrapper>
      {[
        { icon: DirectionsCarRoundedIcon, property: "carTravelTime" as const },
        { icon: DirectionsWalkIcon, property: "walkTravelTime" as const },
        { icon: DirectionsBusIcon, property: "busTravelTime" as const },
      ].map(({ icon, property }, i) => (
        <React.Fragment key={property}>
          <Transporation>
            <TransportationIcon as={icon} />
            <QueryRenderer
              query={travelTimes}
              onLoading={() => <TextShimmer height={19} width={38} />}
              onSuccess={(data) => <TransportationText>{data[property]}</TransportationText>}
              onError={() => <TransportationText>?</TransportationText>}
            />
          </Transporation>
          {i < 2 && <Bullet />}
        </React.Fragment>
      ))}
    </TransportationsWrapper>
  );
}

const TransportationsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 12px;
`;

const Bullet = () => <BulletRoot>•</BulletRoot>;

const BulletRoot = styled.span`
  color: var(--tw-slate-200);
`;

const Transporation = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const TransportationIcon = styled.svg`
  font-size: 24px;
  color: var(--tw-slate-400);
`;

const TransportationText = styled.span`
  font-weight: 600;
  font-size: 14px;
`;
